import React from "react";
import { Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import MaskedInput from "react-text-mask";
import { components } from "react-select";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

// import SearchBox from "../Portfolios/SearchBox";

const FormInput = ({
  name,
  astrict,
  dateFormat,
  minDate,
  onChange,
  showYearPicker,
  placeholder,
  type = "text",
  label,
  disabled,
  options = [],
  className = "",
  guide,
  value,
  suffix,
  prefix = "",
  thousandsSeparator,
  allowNegative,
  decimalLimit,
  integerLimit,
  mask,
  isAddPropertyOption,
  isAddPortfolioOption,
  getPropertyFromEstated,
  postal,
  readOnly = false,
  onBlur,
  isMulti = false,
  styles,
  optional,
  notShowError = false,
  allPortfolios,
  isClearable = true,
  isSearchable = false,
  defaultValue,
  // isSearch,
  changeEmail,
  isCancelable,
  onClickCancel,
  setValue,
  ...rest
}) => {
  const methods = useFormContext();

  function currencyMask(rawValue) {
    let numberMask = createNumberMask({
      prefix: "$",
      includeThousandsSeparator: true,
      allowDecimal: true,
      requireDecimal: true,
      allowLeadingZeroes: false,
    });
    let mask = numberMask(rawValue);

    let decimalsRegex = /\.([0-9]{1,2})/;
    let result = decimalsRegex.exec(rawValue);
    // In case there is only one decimal
    if (result && result[1].length < 2) {
      mask.push("0");
    } else if (!result) {
      mask.push("0");
      mask.push("0");
    }

    return mask;
  }
  const defaultMaskOptions = {
    prefix: prefix ? prefix : "",
    suffix: suffix ? suffix : "",
    includeThousandsSeparator: thousandsSeparator ? true : false,
    thousandsSeparatorSymbol: ",",
    allowDecimal: true,
    decimalSymbol: ".",
    decimalLimit: decimalLimit ? decimalLimit : 2,
    integerLimit: integerLimit,
    allowNegative: allowNegative ? true : false,
    allowLeadingZeroes: false,
    inputMode: "numeric",
  };

  const inputMask = createNumberMask({
    ...defaultMaskOptions,
  });

  const arrFieldName = name?.split(".");
  const isArrayField = arrFieldName?.length >= 2;

  const { Option } = components;

  // TODO fill with logic
  const error = false;
  return (
    <Form.Group autoComplete="off" className={`mb-3 check ${error ? "is-invalid" : ""} ` + className}>
      {type !== "checkbox" && label && (
        <Form.Label className="d-flex justify-content-between">
          <div>
            {label} <span style={{ color: "red" }}>{astrict ? "*" : ""}</span>
          </div>
          <span className="float-right" style={{ color: "gray" }}>
            {optional ? "Optional" : ""}
          </span>
          {isCancelable && <button onClick={onClickCancel} type="button" class="btn-close" aria-label="Close"></button>}
        </Form.Label>
      )}

      {(() => {
        const type = "currency"; // Assuming type is defined here

        switch (type) {
          case "currency":
            return (
              <MaskedInput
                mask={currencyMask}
                onBlur={onBlur}
                type="text"
                guide={guide}
                value={value}
                disabled={disabled}
                className="form-control"
                placeholder={placeholder}
                onChange={(e) => {
                  const conditions = ["%", "$", "-"];
                  let value = conditions.some((ie) => e.target.value.includes(ie))
                    ? e.target.value.includes("$") && e.target.value.includes("-")
                      ? (e.target.value.split("$")[0] + e.target.value.split("$")[1])?.replace(/,/g, "")
                      : e.target.value.includes("$")
                      ? e.target.value.split("$")[1]?.replace(/,/g, "")
                      : e.target.value.split("%")[0]
                    : e.target.value?.replace(/,/g, "");
                  setValue(value);
                }}
              />
            );
          default:
            return null; // Handle other cases or provide a default component
        }
      })()}
      <Form.Text className="text-danger ml-2">{notShowError ? "" : error?.message}</Form.Text>
    </Form.Group>
  );
};

export default FormInput;
